import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './common/services/auth.guard';



export const routes: Routes = [

  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'home-layout'
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: 'home', loadChildren: () => import('./module/home/home.module').then(m => m.HomeModule),
      canActivate: [AuthGuard],
      data: { role: 'home' }  }
    ]
  }, {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'common-layout'
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'citizen' },
      {
        path: 'citizen',
         loadChildren: () => import('./module/citizen/citizen.module').then(m => m.CitizenModule),
         canActivate: [AuthGuard],
         data: { role: 'citizen' }
        }
    ]
  }, {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'common-layout'
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'vle' },
      { path: 'vle', loadChildren: () => import('./module/vle/vle.module').then(m => m.VleModule),
      canActivate: [AuthGuard],  // Apply AuthGuard here
      data: { role: 'vle' }
     }
    ]
  }, {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty-layout'
    },
    children: [
      { path: 'unauthorized', title: 'MahaSarthi', loadChildren: () => import('./module/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
    },
    { path: 'ekyc', loadChildren: () => import('./module/ekyc/ekyc.module').then(m => m.EkycModule),canActivate: [AuthGuard],
       data: { role: 'ekyc' }
    },
    { path: 'userdelete', loadChildren: () => import('../app/module/citizen/deleteuser/deleteuser.module').then(m => m.DeleteuserModule)},
    { path: '', pathMatch: 'full', redirectTo: 'consent-to-access' },
    { path: 'consent-to-access', loadChildren: () => import('./module/consent-to-access/consent-to-access.module').then(m => m.ConsentToAccessModule),
      canActivate: [AuthGuard],
      data: { role: 'citizen' }
     },
     { path: 'consent-to-access-registered', loadChildren: () => import('./module/consent-to-access-registration/consent-to-access-registration.module').then(m => m.ConsentToAccessRegistrationModule),
      canActivate: [AuthGuard]
     },
      { path: 'wait', loadChildren: () => import('./module/wait-condition/wait-condition.module').then(m => m.WaitConditionModule),
      canActivate: [AuthGuard],
      data: { role: 'wait-condition' }
       },
        { path: 'registerSuccess', loadChildren: () => import('./module/register-success/register-success.module').then(m => m.RegisterSuccessModule),
        canActivate: [AuthGuard]
        },

      { path: 'digi-locker', loadChildren: () => import('./module/digi-locker/digi-locker.module').then(m => m.DigiLockerModule),
        canActivate: [AuthGuard],
      data: { role: 'wait-condition' }
      },
      { path: 'processing', loadChildren: () => import('./module/processing/processing.module').then(m => m.ProcessingModule),
        canActivate: [AuthGuard],
      data: { role: 'citizen' }
       },
      { path: 'profile-card', loadChildren: () => import('./module/profile-card/profile-card.module').then(m => m.ProfileCardModule),
        canActivate: [AuthGuard],
      data: { role: 'citizen' }
       },
      { path: 'ekyc-process', loadChildren: () => import('./module/ekyc-process/ekyc-process.module').then(m => m.EkycProcessModule),
      //canActivate: [AuthGuard],
      data: { role: 'citizen' }
       },

    ]
  }, {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty-layout'
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'form-demo' }
    ]
  }];
